// import React, { useState, useEffect, forwardRef, useImperativeHandle } from "react";
// import {
//   Box,
//   Button,
//   Container,
//   Grid,
//   InputLabel,
//   TextField,
//   Typography,
//   useTheme,
// } from "@mui/material";
// import CloudUploadIcon from "@mui/icons-material/CloudUpload";
// import CryptoJS from "crypto-js";
// import Loader from "../loader/Loader";

// const AppDocument = forwardRef(({ initialData = {} }, ref) => {
//   const theme = useTheme();
//   const isDarkMode = theme.palette.mode === "dark";

//   const [employeeDocument, setEmployeeDocument] = useState({
//     employee_id: initialData.employee_id || "",
//     aadhar_card: null,
//     pan_card: null,
//     photograph: null,
//     passport_number: "",
//     passport_expiry_date: "",
//     passport_copy: null,
//   });

//   const [loading, setLoading] = useState(false);
//   const [successMessage, setSuccessMessage] = useState("");
//   const [errorMessage, setErrorMessage] = useState("");

//   useEffect(() => {
//     if (initialData) {
//       setEmployeeDocument((prev) => ({
//         ...prev,
//         ...initialData,
//         employee_id: initialData.employee_id || prev.employee_id,
//       }));
//     }
//   }, [initialData]);

//   const handleFileChange = (e) => {
//     const { name, files } = e.target;
//     setEmployeeDocument((prev) => ({
//       ...prev,
//       [name]: files[0],
//     }));
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setEmployeeDocument((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   const handleDateChange = (e) => {
//     const { name, value } = e.target;
//     // Date format: from yyyy-mm-dd to dd-mm-yyyy
//     const formattedDate = value.split("-").reverse().join("-");
//     setEmployeeDocument((prev) => ({
//       ...prev,
//       [name]: formattedDate,
//     }));
//   };

//   const handleSubmit = async () => {
//     setSuccessMessage("");
//     setErrorMessage("");
//     setLoading(true);

//     try {
//       const encryptedapikey = sessionStorage.getItem("encrypted_data");
//       const base64Key = sessionStorage.getItem("base64_Key");
//       let decryptedjwt = "";

//       if (base64Key && encryptedapikey) {
//         const key = CryptoJS.enc.Base64.parse(base64Key);
//         const dataBytes = CryptoJS.enc.Base64.parse(encryptedapikey);
//         const iv = CryptoJS.lib.WordArray.create(dataBytes.words.slice(0, 4));
//         const ciphertext = CryptoJS.lib.WordArray.create(dataBytes.words.slice(4));
//         const decryptedBytes = CryptoJS.AES.decrypt({ ciphertext }, key, { iv });
//         decryptedjwt = CryptoJS.enc.Utf8.stringify(decryptedBytes);
//       }

//       const formData = new FormData();
//       formData.append("employee_id", employeeDocument.employee_id);
//       formData.append("passport_number", employeeDocument.passport_number);
//       formData.append("passport_expiry_date", employeeDocument.passport_expiry_date);

//       ["aadhar_card", "pan_card", "photograph", "passport_copy"].forEach((field) => {
//         if (employeeDocument[field]) {
//           formData.append(field, employeeDocument[field]);
//         }
//       });
//       const accessToken = JSON.parse(localStorage.getItem('emsUser'))?.user?.stsTokenManager?.accessToken;
//       const response = await fetch(`${process.env.REACT_APP_BACKEND_URL_HRM}/add-employee-document`, {
//         method: "POST",
//         headers: { "X-API-Key": decryptedjwt },
//         body: formData,
//         'Authorization': `Bearer ${accessToken}`
//       });

//       const data = await response.json();
//       if (response.ok) {
//         setSuccessMessage(data.message);
//         return employeeDocument;
//       } else {
//         setErrorMessage(data.message || "Failed to upload documents.");
//         return false;
//       }
//     } catch (error) {
//       console.error("Upload Error:", error);
//       setErrorMessage("An error occurred while uploading documents.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useImperativeHandle(ref, () => ({
//     handleSubmit,
//   }));

//   return (
//     <Container maxWidth="md">
//       {loading && (
//         <Box
//           sx={{
//             position: "fixed",
//             top: 0,
//             left: 0,
//             width: "100vw",
//             height: "100vh",
//             background: "rgba(0, 0, 0, 0.5)",
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//             zIndex: 1000,
//           }}
//         >
//           <Loader />
//         </Box>
//       )}

//       <Box
//         sx={{
//           backgroundColor: isDarkMode ? "background.default" : "white",
//           padding: 4,
//           mt: 5,
//         }}
//       >
//         <Typography
//           variant="h5"
//           textAlign="center"
//           sx={{ mb: 2, fontWeight: "bold", color: isDarkMode ? "text.primary" : "black" }}
//         >
//           Add Employee Document
//         </Typography>

//         <Grid container spacing={2} direction="column">
//           <Grid item xs={12}>
//             <TextField
//               label="Passport Number"
//               name="passport_number"
//               value={employeeDocument.passport_number}
//               onChange={handleChange}
//               fullWidth
//               variant="outlined"
//               InputLabelProps={{
//                 shrink: true,
//                 sx: {
//                   color: theme.palette.mode === "dark" ? "#fff" : "inherit",
//                   "&.Mui-focused": {
//                     color: theme.palette.mode === "dark" ? "#fff" : theme.palette.primary.main,
//                   },
//                 },
//               }}
//               sx={{
//                 "& .MuiOutlinedInput-root": {
//                   borderRadius: 2,
//                   backgroundColor:
//                     theme.palette.mode === "dark" ? "" : theme.palette.background.default,
//                   color: theme.palette.text.primary,

//                   //  Active (focused) background color change
//                   "&.Mui-focused": {
//                     backgroundColor: theme.palette.mode === "dark" ? "hsla(180, 17.20%, 25.10%, 0.92)" : "#f5f5f5",
//                   },

//                   "& fieldset": {
//                     borderColor:
//                       theme.palette.mode === "dark"
//                         ? ""
//                         : "#ccc",
//                   },
//                   "&:hover fieldset": {
//                     borderColor: theme.palette.primary.main,
//                   },
//                   "&.Mui-focused fieldset": {
//                     borderColor: theme.palette.mode === "dark" ? "white" : "#f5f5f5",
//                   },
//                 },
//                 "& .MuiInputBase-input": {
//                   color: theme.palette.text.primary,
//                 },
//               }}
//             />
//           </Grid>

//           <Grid item xs={12}>
//             <TextField
//               label="Passport Expiry Date"
//               type="date"
//               name="passport_expiry_date"
//               value={
//                 employeeDocument.passport_expiry_date
//                   ? employeeDocument.passport_expiry_date.split("-").reverse().join("-")
//                   : ""
//               }
//               onChange={handleDateChange}
//               fullWidth
//               InputLabelProps={{ shrink: true }}
//               variant="outlined"

//             />
//           </Grid>

//           {["aadhar_card", "pan_card", "photograph", "passport_copy"].map((field) => (
//             <Grid item xs={12} key={field}>
//               <InputLabel sx={{ fontWeight: "bold", color: isDarkMode ? "text.primary" : "black" }}>
//                 {field.replace("_", " ").toUpperCase()}
//               </InputLabel>

//               <Button
//                 component="label"
//                 variant="contained"
//                 startIcon={<CloudUploadIcon />}
//                 fullWidth
//                 sx={{
//                   textTransform: "none",
//                   backgroundColor: isDarkMode ? "#4caf50" : "#1976d2",
//                   color: "white",
//                   "&:hover": {
//                     backgroundColor: isDarkMode ? "#388e3c" : "#1565c0",
//                   },
//                 }}
//               >
//                 Upload File
//                 <input type="file" name={field} hidden onChange={handleFileChange} />
//               </Button>

//               {employeeDocument[field] && (
//                 <Typography variant="body2" sx={{ color: "green", mt: 1 }}>
//                   Selected: {employeeDocument[field].name}
//                 </Typography>
//               )}
//             </Grid>
//           ))}
//         </Grid>

//         {successMessage && (
//           <Typography color="green" align="center" mt={2}>
//             {successMessage}
//           </Typography>
//         )}
//         {errorMessage && (
//           <Typography color="red" align="center" mt={2}>
//             {errorMessage}
//           </Typography>
//         )}
//       </Box>
//     </Container>
//   );
// });

// export default AppDocument;

import React, {
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
} from "react";
import {
  Box,
  Button,
  Container,
  Grid,
  InputLabel,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import axios from "axios";
import { useParams } from "react-router-dom";
import { tokens } from "../../../../../theme";
import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "@mui/material/IconButton";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

const AppDocument = forwardRef(
  ({ id: propId = null, employeeId: propEmployeeId = null }, ref) => {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === "dark";
    const params = useParams();
    const colors = tokens(theme.palette.mode);

    // Resolve ID from props or params
    const routeId = params.employee_id || params.employeeId || null;
    const id = propId || propEmployeeId || routeId;

    const [employeeDocument, setEmployeeDocument] = useState({
      employee_id: "",
      aadhar_card: null,
      pan_card: null,
      photograph: null,
      passport_number: "",
      passport_expiry_date: "",
      passport_copy: null,
    });
    const [existingFiles, setExistingFiles] = useState({
      aadhar_card: "",
      pan_card: "",
      photograph: "",
      passport_copy: "",
    });

    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");

    useEffect(() => {
      if (id && id !== "N/A") {
        fetchDocumentData(id);
      } else {
        setEmployeeDocument({
          employee_id: "",
          aadhar_card: null,
          pan_card: null,
          photograph: null,
          passport_number: "",
          passport_expiry_date: "",
          passport_copy: null,
        });
        setExistingFiles({
          aadhar_card: "",
          pan_card: "",
          photograph: "",
          passport_copy: "",
        });
      }
    }, [id]);

    const fetchDocumentData = async (documentId) => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL_HRM}/get-employee-document/${documentId}`
        );

        const data = response.data?.data;
        if (data) {
          setEmployeeDocument({
            employee_id: data.corporate_email_id || "",
            passport_number: data.passport_number || "",
            passport_expiry_date: data.passport_expiry_date || "",
            aadhar_card: null,
            pan_card: null,
            photograph: null,
            passport_copy: null,
          });
          setExistingFiles({
            aadhar_card: data.uploaded_files?.aadhar_card || "",
            pan_card: data.uploaded_files?.pan_card || "",
            photograph: data.uploaded_files?.photograph || "",
            passport_copy: data.uploaded_files?.passport_copy || "",
          });
        } else {
          setEmployeeDocument({
            employee_id: "",
            passport_number: "",
            passport_expiry_date: "",
            aadhar_card: null,
            pan_card: null,
            photograph: null,
            passport_copy: null,
          });
          setExistingFiles({
            aadhar_card: "",
            pan_card: "",
            photograph: "",
            passport_copy: "",
          });
        }
      } catch (err) {
        console.error("Fetch Error:", err);
      }
    };

    const handleFileChange = (e) => {
      const { name, files } = e.target;
      setEmployeeDocument((prev) => ({
        ...prev,
        [name]: files[0],
      }));
    };

    const handleChange = (e) => {
      const { name, value } = e.target;
      setEmployeeDocument((prev) => ({
        ...prev,
        [name]: value,
      }));
    };

    const handleDateChange = (e) => {
      const { name, value } = e.target;
      setEmployeeDocument((prev) => ({
        ...prev,
        [name]: value,
      }));
    };

    const buildFormData = () => {
      const formData = new FormData();

      if (
        employeeDocument.employee_id &&
        employeeDocument.employee_id !== "N/A"
      ) {
        formData.append("employee_id", employeeDocument.employee_id);
      } else if (id) {
        formData.append("employee_id", id);
      }

      formData.append("passport_number", employeeDocument.passport_number);
      formData.append(
        "passport_expiry_date",
        employeeDocument.passport_expiry_date
      );

      ["aadhar_card", "pan_card", "photograph", "passport_copy"].forEach(
        (field) => {
          if (employeeDocument[field]) {
            formData.append(field, employeeDocument[field]);
          }
        }
      );

      return formData;
    };

    const handleSave = async (corporateEmail) => {
      setSuccessMessage("");
      setErrorMessage("");

      try {
        const formDataToSend = buildFormData();
        formDataToSend.append("corporate_email_id", corporateEmail);

        const accessToken = JSON.parse(localStorage.getItem("emsUser"))?.user
          ?.stsTokenManager?.accessToken;

        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_URL_HRM}/add-employee-document`,
          {
            method: "POST",
            headers: {
              // 'Content-Type': 'application/json',
              Authorization: `Bearer ${accessToken}`,
            },
            body: formDataToSend,
          }
        );

        const data = await response.json();
        if (response.ok && data.status === "success") {
          setSuccessMessage(data.message || "Documents uploaded successfully.");

          if (data.document && data.document.employee_id) {
            setEmployeeDocument((prev) => ({
              ...prev,
              employee_id: data.document.employee_id,
            }));
          }
          return data.document || true;
        } else {
          setErrorMessage(data.message || "Failed to upload documents.");
          return false;
        }
      } catch (error) {
        console.error("Upload Error:", error);
        setErrorMessage("An error occurred while uploading documents.");
      }
    };

    const handleUpdate = async () => {
      setSuccessMessage("");
      setErrorMessage("");

      try {
        const formData = buildFormData();
        const accessToken = JSON.parse(localStorage.getItem("emsUser"))?.user
          ?.stsTokenManager?.accessToken;

        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_URL_HRM}/update-employee-document/${id}`,
          {
            method: "PUT",
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
            body: formData,
          }
        );

        const data = await response.json();
        if (response.ok) {
          if (
            data.updated === false ||
            data.message === "No changes detected."
          ) {
            setSuccessMessage(
              "No changes detected. Document remains the same."
            );
          } else {
            setSuccessMessage(
              data.message || "Documents updated successfully."
            );
          }

          fetchDocumentData(id);
          return true;
        } else {
          setErrorMessage(data.message || "Failed to update documents.");
          return false;
        }
      } catch (error) {
        console.error("Update Error:", error);
        setErrorMessage("An error occurred while updating documents.");
      }
    };

    const handleDeleteFile = async (field) => {
      setSuccessMessage("");
      setErrorMessage("");

      if (!id) {
        setErrorMessage("Employee ID missing.");
        return;
      }

      try {
        const accessToken = JSON.parse(localStorage.getItem("emsUser"))?.user
          ?.stsTokenManager?.accessToken;

        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_URL_HRM}/delete-employee-document-file/${id}/${field}`,
          {
            method: "DELETE",
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          }
        );

        const data = await response.json();

        if (response.ok) {
          setSuccessMessage(data.message);
          // Remove the deleted file from existingFiles and employeeDocument states
          setExistingFiles((prev) => ({ ...prev, [field]: "" }));
          setEmployeeDocument((prev) => ({ ...prev, [field]: null }));
        } else {
          setErrorMessage(data.message || "Failed to delete file.");
        }
      } catch (error) {
        console.error("Delete file error:", error);
        setErrorMessage("An error occurred while deleting the file.");
      }
    };

    useImperativeHandle(ref, () => ({
      save: async (corporateEmail) => {
        return await handleSave(corporateEmail);
      },

      update: async () => {
        const result = await handleUpdate();
        return result;
      },
    }));

    const customInputSx = {
      borderRadius: "8px",
      backgroundColor: "transparent",
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "#aaa",
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: "#aaa !important",
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: "#aaa !important",
      },
    };

    const customLabelSx = {
      fontSize: "18px",
      fontWeight: "bold",
      color: colors.grey[100],
      "&.Mui-focused": {
        color: colors.grey[100],
      },
      "&.MuiInputLabel-shrink": {
        color: colors.grey[100],
      },
    };

    return (
      <Container maxWidth="md">
        <Box
          sx={{
            backgroundColor: isDarkMode ? "background.default" : "white",
            padding: 4,
            mt: 5,
          }}
        >
          <Typography
            variant="h5"
            textAlign="center"
            sx={{
              mb: 2,
              fontWeight: "bold",
              color: isDarkMode ? "text.primary" : "black",
            }}
          >
            {id ? "Edit Employee Document" : "Add Employee Document"}
          </Typography>

          <Grid container spacing={2} direction="column">
            <Grid item xs={12}>
              <TextField
                label="Passport Number"
                name="passport_number"
                value={employeeDocument.passport_number || ""}
                onChange={handleChange}
                fullWidth
                required={false}
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                  sx: customLabelSx,
                }}
                InputProps={{
                  sx: customInputSx,
                }}
              />
            </Grid>

            {/* <Grid item xs={12}>
              <TextField
                label="Passport Expiry Date"
                type="date"
                name="passport_expiry_date"
                value={employeeDocument.passport_expiry_date || ""}
                onChange={handleDateChange}
                fullWidth
                required={false}
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                  sx: customLabelSx,
                }}
                InputProps={{
                  sx: customInputSx,
                }}
              />
            </Grid> */}
            <Grid item xs={12}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  label="Passport Expiry Date"
                  value={employeeDocument.passport_expiry_date ? new Date(employeeDocument.passport_expiry_date) : null}
                  onChange={(newValue) => {
                    // Manually create a synthetic event-like object to mimic TextField onChange
                    handleDateChange({
                      target: {
                        name: "passport_expiry_date",
                        value: newValue ? newValue.toISOString().split("T")[0] : "", // Format as yyyy-mm-dd string if needed
                      },
                    });
                  }}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      margin: "normal",
                      InputLabelProps: {
                        shrink: true,
                        sx: customLabelSx,
                      },
                      InputProps: {
                        sx: customInputSx,
                      },
                      sx: {
                        width: "100%",
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "8px",
                          minHeight: "56px",
                        },
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#aaa !important",
                        },
                        "& .MuiInputBase-input": {
                          padding: "12.5px 14px",
                          fontSize: "1rem",
                          color: theme.palette.text.primary,
                        },
                      },
                    },
                  }}
                  // Optional: you can disable manual input with
                  // disableMaskedInput
                />
              </LocalizationProvider>
            </Grid>

            {["aadhar_card", "pan_card", "photograph", "passport_copy"].map(
              (field) => (
                <Grid item xs={12} key={field}>
                  <Box sx={{ flexGrow: 1 }}>
                    <InputLabel
                      sx={{
                        fontWeight: "bold",
                        color: isDarkMode ? "text.primary" : "black",
                      }}
                    >
                      {field.replace("_", " ").toUpperCase()}
                    </InputLabel>

                    <Button
                      component="label"
                      variant="contained"
                      startIcon={<CloudUploadIcon />}
                      fullWidth
                      sx={{
                        textTransform: "none",
                        backgroundColor: isDarkMode ? "#4caf50" : "#1976d2",
                        color: "white",
                        "&:hover": {
                          backgroundColor: isDarkMode ? "#388e3c" : "#1565c0",
                        },
                      }}
                    >
                      Upload File
                      <input
                        type="file"
                        name={field}
                        hidden
                        onChange={handleFileChange}
                      />
                    </Button>

                    {employeeDocument[field] &&
                      typeof employeeDocument[field] !== "string" && (
                        <Typography
                          variant="body2"
                          sx={{ color: "green", mt: 1 }}
                        >
                          Selected: {employeeDocument[field].name}
                        </Typography>
                      )}

                    {id && !employeeDocument[field] && existingFiles[field] && (
                      <Box
                        sx={{
                          mt: 1,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          maxWidth: 360, // optional, to prevent too wide
                        }}
                      >
                        <Typography
                          variant="body2"
                          sx={{ color: isDarkMode ? "text.primary" : "black" }}
                        >
                          Existing File:{" "}
                          <a
                            href={existingFiles[field]}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              color: "#1976d2",
                              textDecoration: "underline",
                            }}
                          >
                            View / Download
                          </a>
                          <IconButton
                            aria-label={`Delete ${field}`}
                            color="error"
                            onClick={() => handleDeleteFile(field)}
                            size="small"
                          >
                            <DeleteIcon />
                          </IconButton>
                        </Typography>
                      </Box>
                    )}
                  </Box>
                </Grid>
              )
            )}
          </Grid>

          {successMessage && (
            <Typography color="green" align="center" mt={2}>
              {successMessage}
            </Typography>
          )}
          {errorMessage && (
            <Typography color="red" align="center" mt={2}>
              {errorMessage}
            </Typography>
          )}
        </Box>
      </Container>
    );
  }
);

export default AppDocument;
